// component
import { IRecommandCollaborationDB } from 'type/wconcepdb';

import MemoCell from 'components/common/table/cell/MemoCell';
import TableCell from 'components/common/table/cell/TableCell';
import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreTag from 'shared/tag/CoreTag';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
// utils
import { setCategoryColor } from 'utils/colorType';
import round, { floatFixed, roundFloat } from 'utils/round';
// type
import { collaboration_header_arr } from 'utils/table';

const useCollabolationTable = (
	platform: 'ig' | 'yt' = 'ig',
	recommendationId?: string,
) => {
	/** cell_type이 number인 cell */
	const NumberCell = (value: number | null, unit: string, idx: number) => {
		const result = value === null ? '-' : `${round(value, 'round')} ${unit}`;
		return (
			<TableCell _width={collaboration_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	/** cell_type이 percent인 cell */
	const percentCell = (value: number | null, idx: number) => {
		const result =
			value === null ? '-' : floatFixed(roundFloat(value, 'round', 2), 2) + '%';
		return (
			<TableCell _width={collaboration_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};

	// 리턴할 객체
	const match_cell_mapper: Record<
		string,
		(data: IRecommandCollaborationDB, idx: number, row_idx: number) => JSX.Element
	> = {
		profile: (data, idx) => (
			<TableCell _width={collaboration_header_arr[idx].width}>
				<Grid
					flex="start"
					_gap="16px"
					_width="100%" // 전체 너비 사용
				>
					<CoreSvg>{platform === 'ig' ? <Icon.Insta /> : <Icon.Youtube />}</CoreSvg>
					<CorePictureAvatar
						size={'default'}
						color_type={'blue'}
						text={data?.username}
						picture={data?.profileImage}
					/>
					<Grid
						flex="start"
						direction="column"
						align_items="start"
						flex_option="1" // 남은 공간 모두 사용
						_overflow="hidden" // overflow 처리
					>
						<Grid _width="100%" _overflow="hidden">
							<EllipsisText typo="p_bold">{data?.username}</EllipsisText>
						</Grid>
						<Grid _width="100%" _overflow="hidden">
							<EllipsisText typo="span">{data?.biography}</EllipsisText>
						</Grid>
					</Grid>
				</Grid>
			</TableCell>
		),
		link: (data, idx) => (
			<TableCell _width={collaboration_header_arr[idx].width} cell_type="center">
				<a
					href={data.link}
					target="_blank"
					onClick={(e) => {
						e.stopPropagation();
					}}
					rel="noreferrer"
				>
					<CoreSvg>
						<Icon.OutLink />
					</CoreSvg>
				</a>
			</TableCell>
		),
		category: (data, idx) => {
			return (
				<TableCell _width={collaboration_header_arr[idx].width}>
					<Grid flex="start">
						<CoreTag
							tag_type="text"
							color_type={setCategoryColor(data?.category1)}
							value={data?.category1}
						/>
						<CoreTag
							tag_type="text"
							color_type={setCategoryColor(data?.category2)}
							value={data?.category2}
						/>
					</Grid>
				</TableCell>
			);
		},

		followers: (data, idx) => {
			return <>{NumberCell(data?.followers, '명', idx)}</>;
		},
		matchingLevel: (data, idx) => {
			return (
				<TableCell _width={collaboration_header_arr[idx].width}>
					<Grid flex="center">
						{data?.matchingLevel === 'mega' && (
							<EllipsisText typo="p_bold">{'S등급/메가'}</EllipsisText>
						)}
						{data?.matchingLevel === 'macro' && (
							<EllipsisText typo="p_bold">{'A등급/매크로'}</EllipsisText>
						)}
						{data?.matchingLevel === 'micro' && (
							<EllipsisText typo="p_bold">{'B등급/마이크로'}</EllipsisText>
						)}
					</Grid>
				</TableCell>
			);
		},
		memo: (data, idx) => {
			return (
				<TableCell _width={collaboration_header_arr[idx].width}>
					<MemoCell
						platform={data?.platform}
						initialMemo={data?.memo}
						recommendationId={data?.recommendationId}
						creatorPk={data?.creatorPk?.toString()}
					/>
				</TableCell>
			);
		},
		contents: (data, idx) => <></>, // State를 보고 있어야함으로 SearchResult에서 처리
	};

	return match_cell_mapper;
};

const { Grid, Text } = style;

export default useCollabolationTable;
